import { CONSTANTS } from '@/types/enum/constants'

const getIsUserIndustryPmiDiy = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles?.find(value => CONSTANTS.ROLE_INDUSTRY_USER_PMI_DIY === value) || false

export default getIsUserIndustryPmiDiy
